import { html, mount } from '../../core/html.js';
import { hasRole } from '../../core/api.js';
import { t } from '../../core/i18n.js';
import { parseHash } from '../../app.js';

const HOST_NAV = [
  ['/host', 'hostnav.dashboard'], ['/host/properties', 'hostnav.properties'], ['/host/calendar', 'hostnav.calendar'], ['/host/bookings', 'hostnav.bookings'],
  ['/messages', 'hostnav.messages'], ['/host/earnings', 'hostnav.earnings'], ['/host/withdrawals', 'hostnav.withdrawals'], ['/host/reviews', 'hostnav.reviews'],
  ['/host/promotions', 'hostnav.promotions'], ['/host/settings', 'hostnav.settings'],
];

const ADMIN_NAV = [
  ['/admin', 'adminnav.dashboard', 'all'], ['/admin/bookings', 'adminnav.bookings', 'all'], ['/admin/payments', 'adminnav.payments', 'finance'],
  ['/admin/withdrawals', 'adminnav.withdrawals', 'finance'], ['/admin/refunds', 'adminnav.refunds', 'finance'], ['/admin/disputes', 'adminnav.disputes', 'all'],
  ['/admin/verifications', 'adminnav.verifications', 'support'], ['/admin/properties', 'adminnav.properties', 'support'], ['/admin/users', 'adminnav.users', 'support'],
  ['/admin/reviews', 'adminnav.reviews', 'support'], ['/admin/promotions', 'adminnav.promotions', 'admin'], ['/admin/categories', 'adminnav.categories', 'admin'],
  ['/admin/reports', 'adminnav.reports', 'finance'], ['/admin/settings', 'adminnav.settings', 'admin'], ['/admin/system', 'adminnav.system', 'admin'], ['/admin/audit', 'adminnav.audit', 'admin'],
];

const CAN = {
  all: () => true,
  finance: () => hasRole('SUPER_ADMIN', 'ADMIN', 'FINANCE'),
  support: () => hasRole('SUPER_ADMIN', 'ADMIN', 'SUPPORT'),
  admin: () => hasRole('SUPER_ADMIN', 'ADMIN'),
};

export function workspace(main, area) {
  const { path } = parseHash();
  const nav = area === 'admin' ? ADMIN_NAV.filter(([, , p]) => CAN[p]()) : HOST_NAV;
  const current = nav.filter(([href]) => path === href || path.startsWith(href + '/')).sort((a, b) => b[0].length - a[0].length)[0]?.[0];
  mount(main, html`<div class="wrap"><div class="work ${area}">
    <nav class="sidenav" aria-label="${t(area === 'admin' ? 'adminnav.aria' : 'hostnav.aria')}">
      <span class="area">${t(area === 'admin' ? 'adminnav.area' : 'hostnav.area')}</span>
      ${nav.map(([href, key]) => html`<a href="#${href}" aria-current="${href === current ? 'page' : null}">${t(key)}</a>`)}
    </nav>
    <section id="work-body" aria-live="polite"></section></div></div>`);
  return main.querySelector('#work-body');
}
